import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { iif, Subscription } from 'rxjs';
import { Observable } from 'rxjs';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { FormsService } from 'src/app/applicationModules/eSignature/services/forms.service';
import { ToastrService } from 'ngx-toastr';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { I } from '@angular/cdk/keycodes';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { FormControl } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
const { detect } = require('detect-browser');
const browser = detect();
import { DatePipe } from '@angular/common';
import { Clipboard } from '@angular/cdk/clipboard';
import { MatRadioChange } from '@angular/material/radio';
export interface State {
  name: string;
  email: string;
  role: string;
  pic: string;
}
@Component({
  selector: 'app-external-task',
  templateUrl: './external-task.component.html',
  styleUrls: ['./external-task.component.scss'],
  providers: [DatePipe],
})
export class ExternalTaskComponent implements OnInit {
  subscription: Subscription;
  setBG = false
  ipAddress: string;
  peoples: any[];
  projectGroups: any[];
  eventLogMessage: any;
  SendButtonDisabled: boolean;
  token: any;
  params: string;
  TaskListID: any;
  organizationId: any;
  userID: any;
  decryptedToken: any;
  myOfficeID: any;
  TaskList: any = [];
  UploadedFilesDragZone: any[];
  formData: FormData;
  responseHolder: any;
  myFormGroup: FormGroup;
  TaskStatusArray: any = [] = [];
  showUpload = true;
  taskStatusList: any = [];
  isLoggedInUser:boolean=false;
  isUserVerified = false;
  isTokenVerified: boolean = false;
  isEntityAttached = false;
  currentVideoTask: any;

  userEmailForTaskList: string
  userEmailForCode: string
  userEmailVerifiedForTaskList = false;

  isEmailVerified = false;

  userFullName = "";
  isEntityIDAttached: boolean = false;
  verifyToken: number = 0;
  tokenValue: any = "";
  entityTypeAttached: number = 0;
  attachedEntityID: number = 0;
  tokenType: number = 0;
  taskTemplateID: number = 0;
  spinner: boolean = false;
  officeName: any = "";
  completedStatusID: any = 0;
  isFromTemplate: boolean = false;
  isOpenURL: any;
  folderID: number = 0;
  panelOpenState = false;
  formID: number=0;
  organizationIdURL: any;
  databaseIdURL: any;
  userIDURL: any;
  myOfficeIDURL: any;
  TaskIDURL: any;
  projectId: number = 0;
  device: any;
  browsername: any;
  type: any;
  groupRelationParticipantMappingID: any;
  groupID: any;
  relationColour: any;
  relationID: any;
  contactemail: any;
  transRoleList: any[];
  contactsList: any[];
  Roles: any[];
  selectedsharedAccessRole: any[];
  participantEmail: string;
  showContactRoleAddButton: boolean;

  stateCtrl = new FormControl();
  filteredStates: Observable<State[]>;
  roleInputCurrentvalue: any;
  stateCtrSendlValue: any;
  stateCtrlValue: string;
  contactId: any;
  selectedTask: any;
  templateDetails: any;
  tasklistURLSendVialEmail: string = "";
  participantMessageInfo: string = null;
  toogleInformation = true;

  ArchEmail: string = "";
  ArchMobile: string = "";
  @ViewChild('Input') InputFile: ElementRef;
  TaskID: number=0;

  constructor(private toastr: ToastrService, private formsService: FormsService,
    private loaderService: LoaderService, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private statusConstant: StatusConstant,
    private http: HttpClient, private httpbackend: HttpBackend,
    private route: ActivatedRoute, private router: Router, @Inject(DOCUMENT)
    private document: Document, private coreService: CoreService,
    private formBuilder: FormBuilder, private dialog: MatDialog,
    private sanitizer: DomSanitizer, private datePipe: DatePipe,private clipboard: Clipboard) {
    this.myFormGroup = new FormGroup({});
    this.subscription = router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url === '/request/task"') {
          this.setBG = true
        }
        else {
          this.setBG = false
        }
      }
    });
    var skipInterceptor = new HttpClient(httpbackend);
    skipInterceptor.get<{ ip: string }>('https://jsonip.com').subscribe(data => {
      this.ipAddress = data.ip
    });
  }
  @ViewChild('participantPopup') participantPopup: TemplateRef<any>;

  openParticipantPopup(participantWithSigningLinkList): void {
    this.dialog.open(this.participantPopup, {
      data:  {
        participantWithSigningLinkList
      },
      width: '474px'
    });
  }

  closeParticipantPopup(): void {
    this.dialog.closeAll();
  }

  signParticipantDocument(signingToken: string): void {
    // Logic to handle document signing
    let url = window.location.href.split(window.location.pathname)[0] + "/request/signature?token=" + signingToken;
              window.open(url, "_blank");
  }

  copyParticipantTokenToClipboard(signingToken: string): void {
    let url = window.location.href.split(window.location.pathname)[0] + "/request/signature?token=" + signingToken;
    this.clipboard.copy(url);
    
    this.toastr.success('Link Copied', '', {
      timeOut: 3000,
    });
  }
  ngOnInit(): void {

    if (browser) {
      this.browsername = browser.name;
      this.device = browser.os;
    }
    this.document.body.classList.add('whiteBg');
    this.getQueryParameter();
    this.getUserEmail();
  }

  taskUserEmail: any;
  accessFrom:string="";
  accessEmail:string="";

  getUserEmail() {
    this.taskUserEmail = sessionStorage.getItem("userEmailForCode")
  }

  getQueryParameter() {
    this.route.queryParams.subscribe(params => {
      this.token = params['token'];
      this.accessFrom = params['access'];
      this.accessEmail= params['email'];
      this.params = decodeURIComponent(this.token);
      const tokenm = this.encryptionAlgo.get(this.reusableClass.encryptionKey, this.params);
      this.decryptedToken = JSON.parse(tokenm);
      this.tokenType = this.decryptedToken.TokenType;
      this.TaskListID = this.decryptedToken.TaskListID;
      this.organizationId = this.decryptedToken.OrganizationID;
      this.userID = this.decryptedToken.UserID;
      this.myOfficeID = this.decryptedToken.OfficeID;
      this.ArchEmail = this.decryptedToken.Email;
      this.ArchMobile = this.decryptedToken.Phoneno;
      this.TaskID=this.decryptedToken.TaskID;
      this.isLoggedInUser=this.decryptedToken.isLoggedInUser==undefined?false:this.decryptedToken.isLoggedInUser;
      if(this.TaskID==undefined){
        this.TaskID=0;
      }
      this.getTaskStatus();
      this.isFromTemplate = this.decryptedToken.isFromTemplate;
      this.isOpenURL = this.decryptedToken.isOpenURL;
      if ((this.decryptedToken.email == undefined || this.decryptedToken.email == '')
        && (this.decryptedToken.Email != undefined && this.decryptedToken.Email != '')
        ) {
          this.decryptedToken.email = this.decryptedToken.Email;
        }
        if ((this.decryptedToken.Email == undefined || this.decryptedToken.Email == '')
        && (this.decryptedToken.email != undefined && this.decryptedToken.email != '')
        ) {
          this.decryptedToken.Email = this.decryptedToken.email;
        }

      if (this.tokenType == 0) {
        if (sessionStorage.getItem("TaskListIDToCheckAuthentication") === this.TaskListID.toString()
          && sessionStorage.getItem("userEmailForCode") !== undefined
          && sessionStorage.getItem("userEmailForCode") !== null) {

          const em = sessionStorage.getItem("userEmailForCode")
     
          this.isOpenURL = true;
        }
        else {
          sessionStorage.removeItem("userEmailForCode")
        }
        if (this.isOpenURL == true && this.decryptedToken.email != undefined && this.decryptedToken.email != '')
        {
          this.userEmailForCode = this.decryptedToken.email;
          sessionStorage.setItem("userEmailForCode", this.decryptedToken.email);
        }
        if (this.decryptedToken.userEmailForCode != undefined && this.decryptedToken.userEmailForCode != null && this.decryptedToken.userEmailForCode != '') {
          this.userEmailForCode = this.decryptedToken.userEmailForCode;
          sessionStorage.setItem("userEmailForCode", this.decryptedToken.userEmailForCode);
        }
        if (this.decryptedToken.userFullName != undefined && this.decryptedToken.userFullName != null && this.decryptedToken.userFullName != '') {
          this.userFullName = this.decryptedToken.userFullName;
        }
        sessionStorage.setItem("TaskListIDToCheckAuthentication", this.TaskListID);
        this.GetTaskByTaskList();
      }
      if(this.TaskListID==0){
       this.openSingleTask();
      }
      if (this.tokenType == 1) {
        //this.taskTemplateID = this.decryptedToken.TaskTemplateID;
        this.folderID = this.decryptedToken.FolderID;
        this.GetTemplateByID(this.decryptedToken.TaskTemplateID);
        //this.TemplateToTaskList();
      }
    });
  }


  archivedTemplateUrlSentLog() {
    let ReqModel = {
      taskListID: this.TaskListID,
      email: this.ArchEmail,
      phoneNo: this.ArchMobile,
      userID: this.userID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      databaseID: 0
    }
    this.formsService.archivedTemplateUrlSentLog(ReqModel).subscribe(response => {
      if (response != undefined) {

      }
    })

  }


  selectFilesFromDragZone(event: any, task: any) {
    this.loaderService.show();
    this.formData = new FormData();
    this.UploadedFilesDragZone = [];
    this.UploadedFilesDragZone = event.target.files;
    for (let i = 0; i < this.UploadedFilesDragZone.length; i++) {
      if (this.UploadedFilesDragZone[i].name.split('.')[0].length > 120) {
        this.toastr.warning('File name upto 120 characters only supported, please rename file.', '', {
          timeOut: 3000,
        });
        this.loaderService.hide();
        return;
      }
      var documenttype = "";
      var documentName = "";
      var FullPath = this.UploadedFilesDragZone[i].name;
      var newfilename = FullPath.replace(/(_\d+(\.\d+)*|\.\d+)+(?=\.pdf$)/g, '');
      var documentNameSplit = newfilename.split('.');
      documentName = documentNameSplit[0];
      documenttype = documentNameSplit[1];
      // if (documentNameSplit.length > 2) {
      //   this.toastr.warning('Please upload valid file name, or remove special character.', '', {
      //     timeOut: 3000,
      //   });
      //   this.InputFile.nativeElement.value = "";
      //   this.loaderService.hide();
      //   return;
      // }
      this.formData.append('files', this.UploadedFilesDragZone[i]);
      this.formData.append('DocumentDetails', documenttype + '|' + '0' + '|' + '1' + '|' + documentName);
    }

    this.formData.append('TaskID', task.taskId.toString());
    this.formData.append('DocumentFolderID', task.documentFolderID.toString());
    this.formData.append('UserID', this.userID);
    this.formData.append('OrganizationID', this.organizationId);
    this.formData.append('OfficeID', this.myOfficeID);
    this.formData.append('OfficeIDList', '0');
    this.formData.append('DatabaseID', '0');
    this.formData.append('ExternalUploadedBy', this.userEmailForCode == undefined ? sessionStorage.getItem("userEmailForCode") : this.userEmailForCode);
    // PUT IF AND ELSE CONDITIONS TO CALL CONTACT OR CORE OR COMPANY api *********
    if (this.entityTypeAttached === 0) {
      this.formData.append('TransactionID', this.attachedEntityID > 0 ? this.attachedEntityID.toString() : task.attachedEntityID.toString());
      this.coreService.AddTaskMultiDocument(this.formData).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          this.UploadedFilesDragZone = [];
          if (this.responseHolder.status == this.statusConstant.statusSuccess) {
            this.loaderService.hide();
            this.toastr.success('File uploaded successfully.', '', {
              timeOut: 3000,
            });
            this.specialUpdate(task);
            this.GetTaskByTaskList();
          }
          else {
            this.toastr.error('File Upload failed.', '', {
              timeOut: 3000,
            });
            this.UploadedFilesDragZone = [];
            this.loaderService.hide();
          }
        } else {
          this.UploadedFilesDragZone = [];
          this.loaderService.hide();
        }
      });
    }
    else if (this.entityTypeAttached === 1) {
      this.formData.append('TransactionID', this.attachedEntityID > 0 ? this.attachedEntityID.toString() : task.attachedEntityID.toString());
      this.coreService.AddCoreMultiDocument(this.formData).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          this.UploadedFilesDragZone = [];
          if (this.responseHolder.status == this.statusConstant.statusSuccess) {
            this.loaderService.hide();
            this.toastr.success('File uploaded successfully.', '', {
              timeOut: 3000,
            });
            this.specialUpdate(task);
            this.GetTaskByTaskList();
          }
          else {
            this.toastr.error('File Upload failed.', '', {
              timeOut: 3000,
            });
            this.UploadedFilesDragZone = [];
            this.loaderService.hide();
          }
        } else {
          this.UploadedFilesDragZone = [];
          this.loaderService.hide();
        }
      });
    }
    else if (this.entityTypeAttached === 2) {
      this.formData.append('TransactionID', this.attachedEntityID > 0 ? this.attachedEntityID.toString() : task.attachedEntityID.toString());
      this.coreService.AddContactMultiDocument(this.formData).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          //const uploadedDocuments = response.data.taskAttached3CMappings[0];       
          this.loaderService.hide();
          this.UploadedFilesDragZone = [];
          if (this.responseHolder.status == this.statusConstant.statusSuccess) {
            this.loaderService.hide();
            this.toastr.success('File uploaded successfully.', '', {
              timeOut: 3000,
            });
            this.specialUpdate(task);
            this.GetTaskByTaskList();
          }
          else {
            this.toastr.error('File Upload failed.', '', {
              timeOut: 3000,
            });
            this.UploadedFilesDragZone = [];
            this.loaderService.hide();
          }
        } else {
          this.UploadedFilesDragZone = [];
          this.loaderService.hide();
        }
      });
    }
    else if (this.entityTypeAttached === 3) {
      this.formData.append('TransactionID', this.attachedEntityID > 0 ? this.attachedEntityID.toString() : task.attachedEntityID.toString());
      this.coreService.AddCompanyMultiDocument(this.formData).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          //  const uploadedDocuments = response.data.taskAttached3CMappings[0];      
          this.loaderService.hide();
          this.UploadedFilesDragZone = [];
          if (this.responseHolder.status == this.statusConstant.statusSuccess) {
            this.loaderService.hide();
            this.toastr.success('File uploaded successfully.', '', {
              timeOut: 3000,
            });
            this.specialUpdate(task);
            this.GetTaskByTaskList();
          }
          else {
            this.toastr.error('File Upload failed.', '', {
              timeOut: 3000,
            });
            this.UploadedFilesDragZone = [];
            this.loaderService.hide();
          }
        } else {
          this.UploadedFilesDragZone = [];
          this.loaderService.hide();
        }
      });
    }

  }

  onddlStatusChange(event, task) {
    if (this.TaskStatusArray !== undefined && this.TaskStatusArray.length >= 0) {
      if (this.TaskStatusArray.find(n => n.taskID == task.taskId) == undefined) {
        this.TaskStatusArray.push({
          taskID: task.taskId,
          status: event,
          position: task.position
        });
      } else {
        this.TaskStatusArray.find(n => n.taskID == task.taskId).status = event;
      }
    }
  }

  UpdateTaskOrTaskListstatus(isUpdateTaskListStatus: boolean = false, _tasklistURL: any = '') {
    var ReqModel = {
      TaskListID: this.TaskListID,
      userID: this.userID,
      organizationID: Number(this.organizationId),
      OfficeID: Number(this.myOfficeID),
      tasks: this.TaskStatusArray,
      isUpdateTaskListStatus: isUpdateTaskListStatus,
      Name: this.userFullName,
      Email: this.userEmailForTaskList,
      emailOfPersonDoingTask: (this.userEmailForCode == undefined ? sessionStorage.getItem("userEmailForCode") : this.userEmailForCode),
      EntityTypeAttached: this.entityTypeAttached, //3C TYPE
      AttachedEntityID: this.attachedEntityID // 3C id
    }
    this.loaderService.show()
    this.formsService.UpdateTaskOrTaskListstatus(ReqModel).subscribe((response) => {
      if (response != undefined) {
        if (response.status == this.statusConstant.statusSuccess) {
          this.loaderService.hide();
          this.toastr.success("Details updated successfully.");
          this.isEmailVerified = false;
          this.isUserVerified == false;
          this.TaskStatusArray = [];
          if (isUpdateTaskListStatus == true) {
            window.location.reload();
          }
          this.GetTaskByTaskList();
        } else {
          this.loaderService.hide();
          this.toastr.error("Status updated failed.")
        }
      } else {
        this.loaderService.hide();
        this.toastr.success("Status updated failed.")
      }
    });
  }

  GetTemplateByID(templateID: any) {
    var ReqModel = {
      TaskTemplateID: templateID,
      userID: this.userID,
      organizationID: Number(this.organizationId),
      OfficeID: Number(this.myOfficeID),
    }
    this.loaderService.show()
    this.spinner = true;
    this.formsService.GetTemplateByID(ReqModel).subscribe((response) => {
      if (response != undefined) {
        if (response.status == this.statusConstant.statusSuccess) {
          this.loaderService.hide();
          this.spinner = false;
          this.templateDetails = response.data;
          this.taskTemplateID = templateID;
          this.attachedEntityID = response.data.attachedEntityID;
          this.entityTypeAttached = response.data.entityTypeAttached;
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

 // taskStatusColors = ['#8f8f8f', '#fdab3d', '#e2445c', '#00c875', '#db241c']
 taskStatusColors = ['#8f8f8f', '#4f66ff', '#fdab3d',  '#00c875', '#db241c']
  statusConstInProgress: any;
  statusConstInOpen: any;
  statusConstCompleted: any;


  getTaskStatus() {
    var ReqModel = {
      userID: this.userID,
      organizationID: Number(this.organizationId),
      OfficeID: Number(this.myOfficeID),
    }
    this.loaderService.show();
    this.coreService.taskStatus(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data != null) {
          this.taskStatusList = this.responseHolder.data;

          this.taskStatusList.map(data =>{
            if(data.taskStatusConstantName == 'blocked'){
              data.taskStatusName = 'Stuck';
            }
          });  

          this.taskStatusList.forEach((data, index) => {
            data.background = this.taskStatusColors[index];

            if (data.taskStatusConstantName == 'open') {

              data.taskStatusName = 'New'
              this.statusConstInOpen = data.taskStatusID
            }
            if (data.taskStatusConstantName == 'inprogress') {
              this.statusConstInProgress = data.taskStatusID
            }

            if (data.taskStatusConstantName == 'completed') {
              this.statusConstCompleted = data.taskStatusID
            }

          })
          this.completedStatusID = this.responseHolder.data.find(m => m.taskStatusConstantName == "completed").taskStatusID;
        }
        else {
          this.loaderService.hide();
        }
      }
      else {
        this.loaderService.hide();
      }
    });
  }

  headerImageUrl: string = "";
  headerText: string = "";
  reSetFormURL(taskId: any, formURL: any) {
    //let formURL = this.myTaskForm.get('formLink').value;
    if (formURL != undefined && formURL !== '' && formURL != null) {
      const getToken = formURL.split("token=")[1];
      if (getToken !== undefined) {
        const params = decodeURIComponent(getToken);
        const encrptedToken = this.encryptionAlgo.get(this.reusableClass.encryptionKey, params);
        const decryptedToken = JSON.parse(encrptedToken)
        decryptedToken.taskID = taskId
        decryptedToken.UserID = this.userID;
        const jsonString = JSON.stringify(decryptedToken)
        const encryptedToken = this.encryptionAlgo.set(this.reusableClass.encryptionKey, jsonString);
        const encryptedTokenWithEncoding = encodeURIComponent(encryptedToken);
        const finalFormURL = formURL.split("token=")[0] + "token=" + encryptedTokenWithEncoding;
        return finalFormURL;
      }
      return formURL;
    }
  }

  showExternalTaskList = [];
  ScheduleTaskList: any = [] = [];
  totalTask = 0;
  inProgressTask = 0;
  openTask = 0;
  completedTask = 0;

  GetTaskByTaskList(isfromTasklist: boolean = false, _tasklistURL: string = "") {
    this.inProgressTask = 0;
    this.completedTask = 0;
    this.totalTask = 0;
    this.openTask = 0;
    var ReqModel = {
      TaskListID: this.TaskListID,
      userID: this.userID,
      organizationID: Number(this.organizationId),
      OfficeID: Number(this.myOfficeID),
      Tasktype: 1,
      TaskID:this.TaskID
    }
    this.spinner = true;
    this.loaderService.show();
    this.formsService.GetTaskGroupsByTaskList(ReqModel).subscribe((response) => {
      if (response != undefined) {
        if (response.status == this.statusConstant.statusSuccess && response.data != null) {
         
          for (let i = response.data.taskGroups.length - 1; i >= 0; i--) {
            if (response.data.taskGroups[i].groupType === 1 && response.data.taskGroups[i].isTriggered === false) {
                response.data.taskGroups.splice(i, 1);
            }
           }

          response.data.taskGroups.map(data => {
            this.totalTask = this.totalTask + data.tasks.length;

            data.tasks.forEach(state => {
              if (state.status == this.statusConstInProgress) {
                this.inProgressTask = this.inProgressTask + 1
              }
              if (state.status == this.statusConstInOpen) {
                state.status = this.statusConstInOpen // Default status is starting from 0 but in default task status list starting from 1
                this.openTask = this.openTask + 1
              }
              if (state.status == 0) {
                state.status = 1
                this.openTask = this.openTask + 1
              }
              if (state.status == this.statusConstCompleted) {
                this.completedTask = this.completedTask + 1
              }
            })
          })


          this.loaderService.hide();
          this.spinner = false;
          this.officeName = response.data.officeName;
          this.showExternalTaskList = [];
          this.ScheduleTaskList = [];
          var taskGroup=[];
          taskGroup =response.data.taskGroups;
          if(taskGroup.length>0){
            for (let i =taskGroup.length - 1; i >= 0; i--) {
              if (taskGroup[i].groupType === 1 && taskGroup[i].isTriggered === false) {
                 taskGroup.splice(i, 1);
              }
           }
          }
          this.showExternalTaskList = taskGroup.filter(x => x.tasks.length > 0);//response.data.taskGroups.filter(x => x.tasks.length > 0);
          this.TaskList = response.data;

          if (this.showExternalTaskList !== undefined && this.showExternalTaskList !== null) {
            this.showExternalTaskList = this.showExternalTaskList.sort(function (a, b) {
              return a.groupPosition - b.groupPosition;
            });

            this.showExternalTaskList.forEach(tg => {
              this.TaskList = response.data;
              if (tg.tasks !== undefined && tg.tasks !== null) {
                tg.tasks.forEach(ts => {
                  // ts.isDisabled = false;
                  // var status=[];
                  // status = this.taskStatusList.filter(x=>x.taskStatusID==ts.status);
                  // if(status.length>0){
                  //   ts.taskStatusConstantName=status[0].taskStatusConstantName;
                  // }else{
                  //   ts.taskStatusConstantName="";
                  // }  

                  this.myFormGroup.addControl("status" + ts.taskId, this.formBuilder.control(''));
                  this.myFormGroup.controls["status" + ts.taskId].setValue(ts.status);

                  ts.formLink = this.reSetFormURL(ts.taskId, ts.formLink);
                  if (ts.formLink != undefined && ts.formLink.includes('request/HtmlFormSign?token')) {
                    ts.isHtmlForm = true;
                  } else {
                    ts.isHtmlForm = false;
                  }
                  this.TaskStatusArray.push({
                    taskID: ts.taskId,
                    status: ts.status,
                    position: ts.position
                  });

                  // if(ts.scheduleTask?.scheduleType==6){
                  //   if(ts.scheduleTask.dependentTaskID>0){
                  //       if(ts.scheduleTask.scheduleData!=null){
                  //         var scheduleData= JSON.parse(ts.scheduleTask.scheduleData);
                  //         var trigger=scheduleData.trigger;
                  //         // var afterbefore=scheduleData.afterbefore;
                  //         // var timenumber=scheduleData.timenumber;
                  //         // var timeperiod=scheduleData.timeperiod;  
                  //         var check11=[];
                  //         var dependentTaskStatus=0;
                  //         check11 = this.taskStatusList.filter(x=>x.taskStatusConstantName==trigger);
                  //         if(check11.length>0){
                  //           dependentTaskStatus=check11[0].taskStatusID;
                  //         }else{
                  //           dependentTaskStatus=0;
                  //         }
                  //         var req={
                  //           scheduleData: scheduleData,
                  //           dependentTaskID:ts.taskId,//ts.scheduleTask.dependentTaskID,
                  //           dependentTaskStatus:dependentTaskStatus//ts.scheduleTask.dependentTaskStatus
                  //          // trigger:trigger                      
                  //         }                   
                  //         this.ScheduleTaskList.push(req);                                  
                  //       }
                  //    }
                  //  }
                });

                tg.tasks = tg.tasks.sort(function (a, b) {
                  return a.position - b.position;
                });
              }
            });


            //  this.showExternalTaskList.forEach(tg => {
            //  this.TaskList = response.data;
            //  if(tg.tasks!==undefined && tg.tasks!==null){
            //     tg.tasks.forEach(ts => {
            //       var check=[];
            //       check = this.ScheduleTaskList.filter(x=> x.dependentTaskID == ts.taskId && x.dependentTaskStatus < ts.status);
            //       if(check.length>0){
            //         ts.isDisabled = true;
            //       }            
            //    });    
            //   }                 
            //  });
          }

          // response.data.getTaskDetailResponseDTOs.forEach(t => {
          //   this.myFormGroup.addControl("status" + t.taskId, this.formBuilder.control(''));
          //   this.myFormGroup.controls["status" + t.taskId].setValue(t.status);
          // });
          // this.TaskList = response.data;
          // this.TaskList.getTaskDetailResponseDTOs.forEach(tls => {
          //   tls.formLink = this.reSetFormURL(tls.taskId, tls.formLink);

          //   if(tls.formLink!=undefined && tls.formLink.includes('request/HtmlFormSign?token')){ 
          //     tls.isHtmlForm=true;
          //   }else {
          //     tls.isHtmlForm=false;
          //   } 

          //   this.TaskStatusArray.push({
          //     taskID: tls.taskId,
          //     status: tls.status
          //   });

          // });


          if (response.data.headerText == null) {
            this.headerText = response.data.taskListName;
          }
          if (response.data.headerText != null) {
            this.headerText = response.data.headerText;
          }
          if (response.data.headerImageUrl != null) {
            this.headerImageUrl = response.data.headerImageUrl;
          }
          if (this.isFromTemplate == true) {
            this.isUserVerified = true;
            this.isEmailVerified = true;
          }
          if (this.isOpenURL == true) {
            if (sessionStorage.getItem("userEmailForCode") != '' && sessionStorage.getItem("userEmailForCode") != undefined) {
              this.userEmailForCode = sessionStorage.getItem("userEmailForCode");
            }
            if(this.userEmailForCode)
            {
              this.taskUserEmail=this.userEmailForCode;
            }
            this.isUserVerified = true;
            this.isEmailVerified = true;
          }
          this.checkIsEntityAttached(_tasklistURL);
        } else {
          this.loaderService.hide();
          this.spinner = false;
        }
      } else {
        this.loaderService.hide();
        this.spinner = false;
      }
    });
  }

  async updateTaskList(email: any) {
    var ReqModel = {
      taskListName: this.headerText + ' : ' + email,
      taskListID: this.TaskListID,
      userID: this.userID,
      organizationID: Number(this.organizationId),
      officeID: Number(this.myOfficeID),
    }
    const result = await this.formsService.renameTasklist(ReqModel).toPromise();
    if (result.status === this.statusConstant.statusSuccess) {
      this.headerText = this.headerText + ' : ' + email;
      this.toastr.success("Task list renamed successfully.", '', {
        timeOut: 3000,
      });
    }
    else {
      this.toastr.error("Task list rename failed.", '', {
        timeOut: 3000,
      });
    }
  }

  TemplateToTaskList() {
    this.spinner = true;
    this.loaderService.show()
    var ReqModel = {
      taskListID: 0,
      taskListName: "",
      position: 0,
      folderID: this.folderID,
      taskTemplateID: this.taskTemplateID,
      userID: this.userID,
      organizationID: Number(this.organizationId),
      officeID: Number(this.myOfficeID),
      templateCreatedUserID: this.decryptedToken.templateCreatedUserID,
      templateCreatedOrganizationID: Number(this.decryptedToken.templateCreatedOrganizationID),
      templateCreatedOfficeID: Number(this.decryptedToken.templateCreatedOfficeID),
      IsComingFormExternalPage: true,
      IsChildDueDate: false,
      userEmailForTaskList: this.userEmailForTaskList,
      userFullName: this.userFullName,
      attachedEntityID: this.attachedEntityID,
      entityTypeAttached: this.entityTypeAttached
    }
    this.formsService.addTasklist(ReqModel).subscribe((response) => {
      if (response != undefined) {
        if (response.status == this.statusConstant.statusSuccess && response.data != null) {
          // this.loaderService.hide();
          // this.spinner = false;
          this.TaskListID = response.data.taskListID;
          sessionStorage.setItem("IscreatedFromTemplate", '1');
          if (this.TaskListID > 0) {
            this.toastr.success('Task List Created Successfully.', '', {
              timeOut: 3000,
            });
            sessionStorage.setItem("TaskListIDToSendEmail", this.TaskListID);
            this.decryptedToken.TokenType = 0;
            this.decryptedToken.TaskTemplateID = 0;
            this.decryptedToken.TaskListID = this.TaskListID;
            this.decryptedToken.isFromTemplate = true;
            this.decryptedToken.userEmailForCode = sessionStorage.getItem("userEmailForCode");
            this.decryptedToken.userFullName = this.userFullName;

            const jsonString = JSON.stringify(this.decryptedToken)
            const encryptedToken = this.encryptionAlgo.set(this.reusableClass.encryptionKey, jsonString);
            const encryptedTokenWithEncoding = encodeURIComponent(encryptedToken);
            let urlSplit = window.location.href.split('token');
            const finalFormURL = urlSplit[0] + "token=" + encryptedTokenWithEncoding;
            //window.location.href = finalFormURL;

            //#region tasklistURLSendVialEmail
            this.decryptedToken.isFromTemplate = false;
            this.decryptedToken.userEmailForCode = "";
            this.decryptedToken.userFullName = "";
            const jsonString1 = JSON.stringify(this.decryptedToken)
            const encryptedToken1 = this.encryptionAlgo.set(this.reusableClass.encryptionKey, jsonString1);
            const encryptedTokenWithEncoding1 = encodeURIComponent(encryptedToken1);
            let urlSplit1 = window.location.href.split('token');
            this.tasklistURLSendVialEmail = urlSplit1[0] + "token=" + encryptedTokenWithEncoding1;

            this.SendExternalURLEmail(this.userEmailForCode, this.tasklistURLSendVialEmail);

            window.location.href = finalFormURL;

            this.spinner = false;
            this.loaderService.hide();
            //Don't need here may be needed in tasklist
            // if ( this.entityTypeAttached>0 && this.attachedEntityID==0) {
            //   this.save3c(finalFormURL);
            // }
            // else
            // {

            // }
            //#endregion
            //will check if needed
            // this.GetTaskByTaskList(true, finalFormURL);
            // not needed
            // this.RecallTemplateToTaskList(ReqModel, finalFormURL)
          }
        } else {
          this.spinner = false;
          this.loaderService.hide();
        }
      } else {
        this.spinner = false;
        this.loaderService.hide();
      }
    });
  }

  // Not needed as functionality is included in AddTasklist Method
  // RecallTemplateToTaskList(ReqModel, _tasklistURL: string = '') {
  //   ReqModel.IsChildDueDate = true;
  //   ReqModel.taskListID = this.TaskListID;
  //   this.formsService.addTasklist(ReqModel).subscribe((response) => {
  //     if (response != undefined) {
  //       if (response.status == this.statusConstant.statusSuccess && response.data != null) {
  //         this.loaderService.hide();
  //         this.spinner = false;
  //         // this.TaskListID = response.data.taskListID;
  //         // sessionStorage.setItem("IscreatedFromTemplate", '1');
  //         if (this.TaskListID > 0) {
  //           this.toastr.success('Child Task List Created Successfully.', '', {
  //             timeOut: 3000,
  //           });
  //         }
  //         this.GetTaskByTaskList(true, _tasklistURL);
  //       } else {
  //         this.spinner = false;
  //         this.loaderService.hide();
  //       }
  //     } else {
  //       this.spinner = false;
  //       this.loaderService.hide();
  //     }
  //   });
  // }

  spinner1: boolean = false;
  Mobilesendtoken: boolean = false;

  GetExterURLToken(email) {

    if (this.showMobile == true) {
      if (this.authenticationMobile == "") {
        this.toastr.warning('Please provide valid mobile no.', '', {
          timeOut: 3000,
        });
        return;
      }
    }
    if (this.showMobile == false) {
      var ReqModel = {
        email: email,
        organizationID: Number(this.organizationId),
        officeID: Number(this.myOfficeID),
      }
      this.showAuthenticationType = false;
      this.isEmailVerified = false;
      this.showMobile = false;
      this.spinner1 = true;
      this.Mobilesendtoken = false;
      this.loaderService.show();
      this.formsService.GetExterURLToken(ReqModel).subscribe((response) => {
        if (response != undefined) {
          if (response.status == this.statusConstant.statusSuccess && response.data != null) {
            this.isEmailVerified = true;
            this.spinner1 = false;
            this.loaderService.hide();
            this.verifyToken = response.data;
          }
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
        }
      });
    }

    if (this.showMobile == true) {
      var ReqModel1 = {
        mobileNo: this.authenticationMobile,
        organizationID: Number(this.organizationId),
        officeID: Number(this.myOfficeID),
      }
      this.isEmailVerified = false;
      this.showAuthenticationType = false;
      this.showMobile = false;
      this.spinner1 = true;
      this.Mobilesendtoken = true;
      this.loaderService.show();
      this.formsService.GetExterURLToken(ReqModel1).subscribe((response) => {
        if (response != undefined) {
          if (response.status == this.statusConstant.statusSuccess && response.data != null) {
            this.isEmailVerified = true;
            this.spinner1 = false;
            this.loaderService.hide();
            this.verifyToken = response.data;
          }
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
        }
      });
    }
  }


  SendExternalURLEmail(email, tasklistURLSendVialEmail: string = '') {
    var ReqModel = {
      email: email,
      ExternalURL: tasklistURLSendVialEmail == '' ? window.location.href : tasklistURLSendVialEmail,
      organizationID: Number(this.organizationId),
      OfficeID: Number(this.myOfficeID),
    }
    this.formsService.SendExternalURLEmail(ReqModel).subscribe((response) => {

      if (response != undefined) {
        if (response.status == this.statusConstant.statusSuccess && response.data != null) {
          if (response.data == true) {
            this.toastr.success("External tasklist url is successfully sent to email.")
          }
        }
      }
    });
  }

  checkIsEntityAttached(_tasklistURL: string = ''): any {
    this.showExternalTaskList.forEach(tg => {
      if (tg.tasks !== undefined && tg.tasks !== null) {
        tg.tasks.forEach(data => {
          this.isEntityIDAttached = data.attachedEntityID > 0;
          this.attachedEntityID = data.attachedEntityID;
          if (this.isEntityAttached == false) {
            this.isEntityAttached = data.entityTypeAttached !== 0;
            this.entityTypeAttached = data.entityTypeAttached;
          }
          if (this.isEntityAttached == true && data.entityTypeAttached !== 0) {
            this.isEntityAttached = data.entityTypeAttached !== 0;
            this.entityTypeAttached = data.entityTypeAttached;
          }
          if (this.isEntityAttached == true && this.isEntityIDAttached == true) {
            return;
          }
        });
      }
    });

    // this.showExternalTaskList.forEach(data => {     
    //   this.isEntityIDAttached = data.attachedEntityID > 0;
    //   this.attachedEntityID = data.attachedEntityID;
    //   if (this.isEntityAttached == false) {
    //     this.isEntityAttached = data.entityTypeAttached !== 0;
    //     this.entityTypeAttached = data.entityTypeAttached;
    //   }
    //   if (this.isEntityAttached == true && data.entityTypeAttached !== 0) {
    //     this.isEntityAttached = data.entityTypeAttached !== 0;
    //     this.entityTypeAttached = data.entityTypeAttached;
    //   }
    //   if (this.isEntityAttached == true && this.isEntityIDAttached == true) {
    //     return;
    //   }
    // })

    // if (this.taskTemplateID > 0 && this.isEntityAttached == true && this.isEntityIDAttached ==false) {
    //   this.save3c(_tasklistURL);
    // }
    // else if (this.taskTemplateID > 0 )
    // {
    //   window.location.href = _tasklistURL;
    // }
  }

  checkIsEntityAttachedHasID(): any {
    this.showExternalTaskList.forEach(tg => {
      if (tg.tasks !== undefined && tg.tasks !== null) {
        tg.tasks.forEach(data => {
          this.isEntityAttached = data.attachedEntityID !== 0
          if (this.isEntityAttached == true) {
            return;
          }
        });
      }
    });

    // this.showExternalTaskList.forEach(data => {
    //   this.isEntityAttached = data.attachedEntityID !== 0
    //   if (this.isEntityAttached == true) {
    //     return;
    //   }
    // })
  }


  // checkIsEntityAttached(): any {
  //   this.TaskList.getTaskDetailResponseDTOs.forEach(data => {     
  //     this.isEntityIDAttached = data.attachedEntityID > 0;
  //     this.attachedEntityID = data.attachedEntityID;
  //     if (this.isEntityAttached == false) {
  //       this.isEntityAttached = data.entityTypeAttached !== 0;
  //       this.entityTypeAttached = data.entityTypeAttached;
  //     }
  //     if (this.isEntityAttached == true && data.entityTypeAttached !== 0) {
  //       this.isEntityAttached = data.entityTypeAttached !== 0;
  //       this.entityTypeAttached = data.entityTypeAttached;
  //     }
  //     if (this.isEntityAttached == true && this.isEntityIDAttached == true) {
  //       return;
  //     }
  //   })
  // }

  // checkIsEntityAttachedHasID(): any {
  //   this.TaskList.getTaskDetailResponseDTOs.forEach(data => {
  //     this.isEntityAttached = data.attachedEntityID !== 0
  //     if (this.isEntityAttached == true) {
  //       return;
  //     }
  //   })
  // }


  closeEmailPopup() {
    this.dialog.closeAll();
    this.verifyToken = 0;
    this.showMobile = false;
  }

  AskEmail(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef);
  }
  
  startTaskList(templateRef: TemplateRef<any>, concernedPerson: TemplateRef<any>) {
    // if(this.accessFrom =="portal"){
    //   this.isUserVerified = true;
    //   this.isEmailVerified = true;
    //   this.userFullName="";
    //   this.taskUserEmail = this.accessEmail;
    //   return;
    // }
    if (this.isOpenURL == true) {
      this.userEmailForCode = this.decryptedToken.email;
      this.taskUserEmail=this.decryptedToken.email;
      if (this.isEntityAttached == true && this.isEntityIDAttached == false) {
        // this.dialog.open(concernedPerson);
        // return;
        let fields = this.userEmailForCode.split('@');
        if (fields.length > 0) {
          this.userFullName = fields[0];
          this.userEmailForTaskList = this.userEmailForCode;
          this.isUserVerified = true;
          this.isEmailVerified = true;
          //this.save3c();
        }
      }
      this.isUserVerified = true;
      this.isEmailVerified = true;
    } else {
      this.dialog.open(templateRef);
    }
  }

  getConcernedConfirmation(templateRef: TemplateRef<any>) {
    if (this.verifyToken == this.tokenValue) {
      this.dialog.closeAll();
      sessionStorage.setItem("userEmailForCode", this.userEmailForCode);
      this.toastr.success("Token verified successfully.");
      this.archivedTemplateUrlSentLog();
    } else {
      this.toastr.error("Token verification failed.");
      return;
    }

    if (this.taskTemplateID > 0) {
      this.TemplateToTaskList();     
    }
    else {
      if (this.isEntityAttached == true && this.isEntityIDAttached == false) {
        
        let splitTaskList = this.headerText.split(':');
        if (splitTaskList.length == 2 && this.userEmailForCode != undefined && this.userEmailForCode != null && this.userEmailForCode.toLowerCase() == splitTaskList[1].trim().toLowerCase()) {
          //this.dialog.open(templateRef);
          this.isUserVerified = true;
          this.isEmailVerified = true;
          this.save3cNew();        
        }
        else if (splitTaskList.length == 1) {
          this.isUserVerified = true;
          this.isEmailVerified = true;
          //this.dialog.open(templateRef);
          this.save3cNew();        
        }
        else {         
          this.isUserVerified = true;
        }
      } else {        
        this.isUserVerified = true;
      }
    }
  }

  getTaskListName(name: any) {
    if (name != undefined) {
      let splitTaskList = name.split(':');
      if (splitTaskList.length == 2) {
        return splitTaskList[0];
      }
    }
    return name;
  }


  SendVerfyTokenMethod(templateRef: TemplateRef<any>) {
    this.GetExterURLToken(this.userEmailForCode);
    var fields = [];
    fields = this.userEmailForCode.split('@');
    if (fields.length > 0) {
      //this.userFullName = fields[0];
      this.userEmailForTaskList = this.userEmailForCode;
    }
    if (this.isFromTemplate == true && this.TaskListID == sessionStorage.getItem('TaskListIDToSendEmail')) {
      sessionStorage.removeItem('TaskListIDToSendEmail');
      this.SendExternalURLEmail(this.userEmailForCode);
    }
  }


  getEmailVerified() {
    let emailVerified: boolean;
    const regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    emailVerified = regexp.test(this.userEmailForCode);
    this.isEmailVerified = emailVerified;

  }

  getEmailVerified3c() {
    let emailVerified: boolean;
    const regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    emailVerified = regexp.test(this.userEmailForTaskList);
    this.userEmailVerifiedForTaskList = emailVerified;
  }

  getEmailVerifiedForProvider() {
    let emailVerified: boolean;
    const regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    emailVerified = regexp.test(this.ProviderEmail);
    this.userEmailVerifiedForProvider = emailVerified;
    if (this.ProviderFullName.trim() == "") {
      this.userEmailVerifiedForProvider = false;
    }
  }

  noConcernedPerson() {
    this.dialog.closeAll();
    this.isUserVerified = true;
    this.isEmailVerified = true;
  }

  RelationsList: any = [] = [];
  ProviderFullName: string = "";
  ProviderEmail: string = "";
  userEmailVerifiedForProvider: boolean = false;

  yesConcernedPerson(templateRef: TemplateRef<any>) {
    this.participantemail = "";
    // this.userEmailVerifiedForProvider=false;
    if (this.userFullName != "" && this.userEmailForTaskList != "") {
      this.userEmailVerifiedForTaskList = true;
    } else {
      this.userEmailVerifiedForTaskList = false;
    }
    this.dialog.closeAll();
    this.dialog.open(templateRef);
    // this.RelationsList = [
    //   {
    //     relationId:1,   
    //     relation: "Doctor", 
    //     info: [
    //       {
    //         id:1,
    //         email: "test1@mailinator.com",
    //         projectName:"One"
    //       }, 
    //       {
    //         id:2,
    //         email: "test2@mailinator.com",
    //         projectName:"Two"
    //       },             
    //     ]
    //   },
    //   {
    //     relationId:2,
    //     relation: "Patient", 
    //     info: [
    //       {
    //         id:3,
    //         email: "test3@mailinator.com",
    //         projectName:"Three"
    //       },
    //       {
    //         id:4,
    //         email: "test4@mailinator.com",
    //         projectName:"Four"
    //       },             
    //     ]
    //   },  
    // ]
    // this.RelationsList = [
    //   { relation: 'Doctor', email: 'test@mailinator.com', projectName: 'One'},
    //   { relation: 'Doctor', email: 'test1@mailinator.com', projectName: 'Two'},
    //   { relation: 'Patient', email: 'test2@mailinator.com', projectName: 'Three'},
    //   { relation: 'Patient', email: 'test3@mailinator.com', projectName: 'Four'},
    //  ];
  }

  checkProviderName(name: string) {
    if (name.trim() != "" && this.ProviderEmail.trim() != "") {
      let emailVerified: boolean;
      const regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
      emailVerified = regexp.test(this.ProviderEmail);
      this.userEmailVerifiedForProvider = emailVerified;
    } else {
      this.userEmailVerifiedForProvider = false;
    }
  }



  dialogRef: any;

  // closeAssign() {
  //   if (this.dialogRef != undefined) {
  //     this.dialogRef.close();
  //   }
  // }

  showAddButton: boolean = false;
  participantemail: string = "";
  selectedId: number = 0;
  showAddForRelation: boolean = false;
  currentIndex: any = 0;
  EmailFill: boolean = true;

  getindex(i: any) {
    this.participantemail = "";
    this.currentIndex = i;
  }

  addEmailInRelation(searchValue: any, data: any, i: any) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var check = re.test(String(searchValue).toLowerCase());
    this.currentIndex = i;
    if (check == true) {
      //this.participantemail=searchValue;
      this.showAddForRelation = true;
      this.RelationsList;
      var check1 = [];
      check1 = data.info;
      if (check1.length > 0) {
        for (var i1 = 0, len = check1.length; i1 < len; ++i1) {
          check1.find((item) => item.id == check1[i1].id).email = searchValue;
        }
      }
    }
    if (check == false) {
      this.showAddForRelation = false;
    }
  }

  addEmailInProject(searchValue: any, p: any, data: any, i: any) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var check = re.test(String(searchValue).toLowerCase());

    if (check == true) {
      this.RelationsList;
      var check1 = [];
      check1 = data.info.filter(x => x.id == p.id);
      if (check1.length > 0) {
        for (var i1 = 0, len = check1.length; i1 < len; ++i1) {
          check1.find((item) => item.id == check1[i1].id).email = searchValue;
        }
      }

      //  this.showAddForRelation = true;
      //  if(i==0 && this.EmailFill==true){
      //   this.RelationsList;
      //   var check1=[];
      //   check1 = data.info;
      //   if(check1.length>0){
      //     for (var i1 = 0, len = check1.length; i1 < len; ++i1) {     
      //       check1.find((item) => item.id == check1[i1].id).email = searchValue;                
      //     } 
      //   }      
      // }else{
      //   this.RelationsList;
      //   var check1=[];
      //   check1 = data.info.filter(x=>x.id==p.id);
      //   if(check1.length>0){
      //     for (var i1 = 0, len = check1.length; i1 < len; ++i1) {     
      //       check1.find((item) => item.id == check1[i1].id).email = searchValue;                
      //     } 
      //   }   
      // }    
    }

  }

  onChangeFill(ob: MatCheckboxChange) {
    this.EmailFill = ob.checked;
  }


  searchUser(searchValue: any) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var check = re.test(String(searchValue).toLowerCase());

    if (check == true) {
      //   var ReqModels={
      //   contactID: 0,
      //   email: searchValue,
      //   img:"",         
      //   name: "",
      //   shortName: ""
      //  } 
      this.participantemail = searchValue;
      this.showAddButton = true;
      //  this.SendButtonDisabled=true;             
    }
    if (check == false) {
      this.showAddButton = false;
      // this.SendButtonDisabled=false;     
    }
  }
  timeout = null;
  searchUserProject(val) {
    this.contactsList = [];
    if (val != '') {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.getContactListCoreImplementation(val)
      }, 500);
    } else {
      this.contactsList = [];
    }
  }

  getContactListCoreImplementation(searchValue: any) {
    var ReqModel = {
      DatabaseID: Number(this.databaseIdURL),
      OrganizationID: Number(this.organizationIdURL),
      UserID: this.userID,
      searchValue: searchValue,
      PageSize: 0,
    }
    this.formsService.GetContactListCoreImplementation(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.peoples = [];
          this.contactsList = response.data.contactListModel;
          this.contactsList.forEach(e => {
            e.shortName = e.name.match(/\b(\w)/g).join('');
          });

          const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          var check = re.test(String(searchValue).toLowerCase());

          if (check == true) {
            var ReqModels = {
              contactID: 0,
              email: searchValue,
              img: "",
              name: "",
              shortName: ""
            }
            this.contactemail = searchValue;
            this.showAddButton = true;
            this.SendButtonDisabled = true;
          }
          if (check == false) {
            this.showAddButton = false;
            this.SendButtonDisabled = false;
          }
        } else {
          this.contactsList = [];
        }
      }
    }

    )
  }

  addUpdateParticipants() {
    var name = "";
    if (this.peoples.length > 0) {
      if (this.peoples[0].email != "" || this.peoples[0].email != null || this.peoples[0].email != undefined) {
        this.contactemail = this.peoples[0].email;
        name = this.peoples[0].name;
        this.contactId = this.peoples[0].contactID;
      }
    }
    if (this.peoples.length == 0) {
      this.contactId = 0;
    }
    if (this.contactemail != "" || this.contactemail != null || this.contactemail != undefined) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var check = re.test(String(this.contactemail).toLowerCase());
      if (check == true) {
      } else {
        this.toastr.warning('Please provide valid email.', '', {
          timeOut: 3000,
        });
        return;
      }
    }

    this.closeAssignParticipant();
    this.loaderService.show();
    this.projectGroups.forEach(e => {
      if (e.projGrpRelationParticipantList.length > 0) {
        e.projGrpRelationParticipantList.forEach(ee => {
          if (ee.groupRelationParticipantMappingID == this.groupRelationParticipantMappingID) {
            ee.contactEmail = this.contactemail;
            ee.participantName = name;
          }
        });
      }
    });
    this.SendButtonDisabled = true;
    var ReqModel = {
      groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
      contactEmail: this.contactemail,
      contactID: this.contactId,
      officeID: this.myOfficeIDURL,
      userID: this.userIDURL,
      databaseID: Number(this.databaseIdURL),
      organizationID: Number(this.organizationIdURL),
    }
    // return;
    this.formsService.UpdateParticipantDeatil(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.peoples = [];
          this.showAddButton = false;
          this.loaderService.hide();
        } else {
          this.peoples = [];
          this.showAddButton = false;
          this.loaderService.hide();
        }
      } else {
        this.peoples = [];
        this.showAddButton = false;
        // this.SendButtonDisabled=false;
        this.loaderService.hide();
      }
    });
  }

  saveProviderInformation() {
    this.dialog.closeAll();
    this.isUserVerified = true;
    this.isEmailVerified = true;
    // this.save3c();
  }

  allDetailsCollected() {
    this.dialog.closeAll();
    this.isUserVerified = true;
    this.isEmailVerified = true;
    // this.save3c();
  }

  proceedSingleTaskTemp() {    
    //this.isUserVerified = true;
    //this.isEmailVerified = true;
    // this.save3c();
    this.userEmailForCode =this.userEmailForTaskList;
    sessionStorage.setItem("userEmailForCode",this.userEmailForTaskList);
    this.dialog.closeAll();
  }

  save3cDiscontinued(_tasklistURL: string = '') {
    let reqModel = {
      userID: this.userID,
      name: this.userFullName,
      email: this.userEmailForTaskList,
      databaseID: 0,
      organizationID: this.organizationId,
      officeID: this.myOfficeID
    }
    if (this.entityTypeAttached === 1) {
      this.coreService.AddTaskCore(reqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConstant.statusSuccess) {
            this.loaderService.hide();
            // getting on load of task list
            this.attachedEntityID = this.responseHolder.data;
            this.SendExternalURLEmail(this.userEmailForCode, this.tasklistURLSendVialEmail);
            this.UpdateTaskOrTaskListstatus(false, _tasklistURL);
            //this.GetTaskByTaskList();
            if (this.taskTemplateID > 0 && _tasklistURL != '') {
              window.location.href = _tasklistURL
            }

            this.toastr.success('Concerned person added successfully.', '', {
              timeOut: 3000,
            });

            // Not needed doing in TemplateToTaskList method
            // if (sessionStorage.getItem("IscreatedFromTemplate") == '1') {
            //   this.updateTaskList(this.userEmailForTaskList);
            //   sessionStorage.removeItem("IscreatedFromTemplate");
            // }

            /// need to uncomment if not reloading
            // if (this.taskTemplateID > 0 && _tasklistURL != '') {
            //   window.location.href = _tasklistURL
            // }

          }
        }
      });
    }
    else if (this.entityTypeAttached === 2) {
      this.coreService.AddTaskContact(reqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConstant.statusSuccess) {
            this.loaderService.hide();
            // getting on load of task list 
            this.attachedEntityID = this.responseHolder.data;
            this.SendExternalURLEmail(this.userEmailForCode);
            this.UpdateTaskOrTaskListstatus(false, _tasklistURL);
            this.toastr.success('Concerned person added successfully.', '', {
              timeOut: 3000,
            });

            // Not needed doing in TemplateToTaskList method
            // if (sessionStorage.getItem("IscreatedFromTemplate") == '1') {
            //   this.updateTaskList(this.userEmailForTaskList);
            //   sessionStorage.removeItem("IscreatedFromTemplate");
            // }

            /// need to uncomment if not reloading
            // if (this.taskTemplateID > 0 && _tasklistURL != '') {
            //   window.location.href = _tasklistURL
            // }

          }
        }
      });
    }
    else if (this.entityTypeAttached === 3) {
      this.coreService.AddTaskCompany(reqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConstant.statusSuccess) {
            this.loaderService.hide();
            // getting on load of task list 
            this.attachedEntityID = this.responseHolder.data;
            this.SendExternalURLEmail(this.userEmailForCode);
            this.UpdateTaskOrTaskListstatus(false, _tasklistURL);
            this.toastr.success('Concerned person added successfully.', '', {
              timeOut: 3000,
            });

            // Not needed doing in TemplateToTaskList method
            // if (sessionStorage.getItem("IscreatedFromTemplate") == '1') {
            //   this.updateTaskList(this.userEmailForTaskList);
            //   sessionStorage.removeItem("IscreatedFromTemplate");
            // }

            /// need to uncomment if not reloading
            // if (this.taskTemplateID > 0 && _tasklistURL != '') {
            //   window.location.href = _tasklistURL
            // }
          }
        }
      });
    }
  }

  save3cNew(_tasklistURL: string = '') {
    let reqModel = {
      userID: this.userID,
      name: this.userFullName,
      email: this.userEmailForTaskList,
      databaseID: 0,
      organizationID: this.organizationId,
      officeID: this.myOfficeID,
      EntityTypeAttached: this.entityTypeAttached,
      AttachedEntityID: this.attachedEntityID,
      TaskListID: this.TaskListID

    }

    this.formsService.Save3cNew(reqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.loaderService.hide();
          // getting on load of task list
          this.attachedEntityID = this.responseHolder.data;
          //this.SendExternalURLEmail(this.userEmailForCode, this.tasklistURLSendVialEmail);
          // this.UpdateTaskOrTaskListstatus(false, _tasklistURL);

          this.toastr.success('Concerned person added successfully.', '', {
            timeOut: 3000,
          });

          // Not needed doing in TemplateToTaskList method
          // if (sessionStorage.getItem("IscreatedFromTemplate") == '1') {
          //   this.updateTaskList(this.userEmailForTaskList);
          //   sessionStorage.removeItem("IscreatedFromTemplate");
          // }

          /// need to uncomment if not reloading
          // if (this.taskTemplateID > 0 && _tasklistURL != '') {
          //   window.location.href = _tasklistURL
          // }

        }
      }
    });

  }

  openFormLink(task) {
    //  if(task.isDisabled==true){
    //   return
    //  }
    if (task.formLink != null && task.formLink != "" && task.formLink != undefined) {
      if (task.formLink.substring(0, 4) == 'http') {
        window.open(task.formLink, '_blank');
      } else {
        window.open('https://' + task.formLink, '_blank');
      }
    } else {
      this.toastr.warning('No URL or link is provided to open.', '', {
        timeOut: 3000,
      });
    }

    //this.GetSigningLinkForParticipantIfExists(task);
  }

  safeSrcVedio: SafeResourceUrl;

  openVedioLink(task, templateRef: TemplateRef<any>) {
    //  if(task.isDisabled==true){
    //   return
    //   }
    this.currentVideoTask = task;
    this.safeSrcVedio = "";
    if (task.formLink != null && task.formLink != "" && task.formLink != undefined) {
     task.formLink=this.convertToYouTbubeEmbeddedLink(task.formLink);
     task.formLink=this.convertToDailymotionEmbeddedLink(task.formLink);
      if (task.action == 4) {
        if (task.formLink.substring(0, 4) == 'http') {
          this.safeSrcVedio = this.sanitizer.bypassSecurityTrustResourceUrl(task.formLink);
          // this.safeSrcVedio = task.formLink;
          this.dialogRef = this.dialog.open(templateRef, {
            panelClass: 'custom-modalbox',
            disableClose: true,
          });
          return;
        }
      }
      if (task.formLink.substring(0, 4) == 'http') {
        window.open(task.formLink, '_blank');
      } else {
        window.open('https://' + task.formLink, '_blank');
      }
    } else {
      this.toastr.warning('No URL or link is provided to open.', '', {
        timeOut: 3000,
      });
    }
  }

   convertToDailymotionEmbeddedLink(link) {
    // Regular expression to match DailyMotion video ID
    var dailymotionRegex = /^(?:https?:\/\/)?(?:www\.)?(dailymotion\.com\/video\/)([a-zA-Z0-9]+)/;
    // Regular expression to match DailyMotion embedded link
    var embeddedRegex = /^(?:https?:\/\/)?(?:www\.)?(dailymotion\.com\/embed\/video\/)([a-zA-Z0-9]+)/;

    // Check if the link is a DailyMotion link
    var isDailyMotionLink = link.match(dailymotionRegex);

    // If the link is a DailyMotion link, proceed to check if it's an embedded link
    if (isDailyMotionLink) {
        // Check if the link is already an embedded link
        var isEmbeddedLink = link.match(embeddedRegex);

        // If the link is not already an embedded link, convert it
        if (!isEmbeddedLink) {
            // Extract video ID from the DailyMotion link
            var videoId = link.match(dailymotionRegex)[2];

            // Construct embedded link using the extracted video ID
            var embeddedLink = "https://www.dailymotion.com/embed/video/" + videoId + "?autoplay=1";
            return embeddedLink;
        }
    }

    // Return the original link if it's not a DailyMotion link or if it's already an embedded link
    return link;
}
  convertToYouTbubeEmbeddedLink(link) {
    // Regular expression to match YouTube link
    var youtubeRegex = /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    
    // Check if the link is a YouTube link
    var isYoutubeLink = link.match(youtubeRegex);

    if (isYoutubeLink) {
        // Regular expression to match YouTube embedded link
        var embeddedRegex = /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/;

        // Check if the link is already in embedded format
        var isEmbeddedLink = link.match(embeddedRegex);

        if (!isEmbeddedLink) {
            // Extract video ID from the YouTube link
            var videoId = link.match(youtubeRegex)[1];

            // Construct embedded link using the extracted video ID
            var embeddedLink = "https://www.youtube.com/embed/" + videoId + "?si=-mIhLhknfP-YXeG7";
            return embeddedLink;
        }
    }

    // Return the original link if it's not a YouTube link or if it's already in embedded format
    return link;
}


  specialUpdate(task) {
    if (task.taskId) {
      this.showExternalTaskList.forEach(tg => {
        if (tg.tasks !== undefined && tg.tasks !== null) {
          tg.tasks.forEach(ts => {
            ts.status = ts.taskId == task.taskId ? this.completedStatusID : ts.status;
            this.TaskStatusArray.filter(m => m.taskID == task.taskId).forEach(tsa => {
              tsa.status = this.completedStatusID;
            });
          });
        }
      });
      this.UpdateTaskOrTaskListstatus();
    }
  }

  closeVedio() {
    this.dialogRef.close();
    this.safeSrcVedio = "";
    this.specialUpdate(this.currentVideoTask);
    this.currentVideoTask = {};
  }

  getQueryParameterFromLink(tokenURL: any) {
    this.token = tokenURL;
    this.params = decodeURIComponent(this.token);
    const tokenm = this.encryptionAlgo.get(this.reusableClass.encryptionKey, this.params);
    let decryptedToken = JSON.parse(tokenm)
    this.formID = decryptedToken.FormID;
    this.organizationIdURL = decryptedToken.OrganizationID;
    this.databaseIdURL = decryptedToken.DatabaseID;
    this.userIDURL = decryptedToken.UserID;
    this.myOfficeIDURL = decryptedToken.OfficeID
    this.TaskIDURL = decryptedToken.taskID == undefined ? 0 : decryptedToken.taskID;
  }

  GetSigningLinkForParticipantIfExists(task, templateRefAccept: TemplateRef<any>, templateRef: TemplateRef<any>) {
    //  if(task.isDisabled==true){
    //   return
    //  }
    //this.loaderService.show();
    this.selectedTask = task;
    if (task.formLink == undefined) {
      this.toastr.warning('Form link is not provided.', '', {
        timeOut: 3000,
      });
      return;
    }
    if (task.formLink != undefined && task.formLink.includes('request/HtmlFormSign?token')) {
      window.open(task.formLink, "_blank");
      return;
    }
    this.loaderService.show();
    var ReqModel = {
      projectID: task.projectID,
      taskID: task.taskId,
      userID: this.userID,
      organizationID: Number(this.organizationId),
      OfficeID: Number(this.myOfficeID),
    }
    this.formsService.GetProjectParticicpantWithSigningLinkByProjectID(ReqModel).subscribe((response) => {
      if (response != undefined) {
        if (response.status == this.statusConstant.statusSuccess && response.data != null) {
          if (response.data.particicpantWithSigningLinkList != null && response.data.particicpantWithSigningLinkList != undefined && response.data.particicpantWithSigningLinkList.length > 0) {
            if(this.isLoggedInUser==true && response.data.projectID > 0 && response.data.status >0)
              {
                let particicpantWithSigningLinkListCopy=response.data.particicpantWithSigningLinkList.filter(m=> (m.email!=null && m.email!=undefined && m.email!='') || ( m.name!=null && m.name!=undefined && m.name!=''))
                this.openParticipantPopup(particicpantWithSigningLinkListCopy);
                this.loaderService.hide();
                return;
              }
            this.participantMessageInfo = response.data.participantMessageInfo;
            response.data.particicpantWithSigningLinkList = response.data.particicpantWithSigningLinkList.filter(x => x.email != '' && x.email != undefined && x.email != null);
            let VerifiedEmail = response.data.particicpantWithSigningLinkList.find(x => x.email.toLowerCase() == sessionStorage.getItem("userEmailForCode")?.toLowerCase());
            if (VerifiedEmail != undefined) {
              if (response.data.projectID > 0 && response.data.status == 0) {
                let splitURl = task.formLink.split('token=');
                this.getQueryParameterFromLink(splitURl[1]);
                this.GetparticipantIfprojectExists(templateRef, response.data.projectID);
              }
              else {
                this.loaderService.hide();
                let url = window.location.href.split(window.location.pathname)[0] + "/request/signature?token=" + VerifiedEmail.signingToken;
                window.open(url, "_blank");
              }
            }
            else {
              if (response.data.projectID > 0 && response.data.status == 0) {
                let splitURl = task.formLink.split('token=');
                this.getQueryParameterFromLink(splitURl[1]);
                this.GetparticipantIfprojectExists(templateRef, response.data.projectID);
              } else {
                this.toastr.warning('You are not an assigned participant', '', {
                  timeOut: 3000,
                });
                if (response.data.particicpantWithSigningLinkList != undefined && response.data.particicpantWithSigningLinkList.length > 0) {
                  let emailList = Array.prototype.map.call(response.data.particicpantWithSigningLinkList, function (item) { return item.email; }).join(", ");
                  this.toastr.warning('The following emails correspond to the respective participants: ' + emailList, '', {
                    timeOut: 6000,
                  });
                }
                this.loaderService.hide();
              }
            }
          }
          else {
            if (task.formLink != null && task.formLink != "" && task.formLink != undefined) {
              if (task.formLink.substring(0, 4) == 'http') {
                let splitURl = task.formLink.split('token=');
                this.getQueryParameterFromLink(splitURl[1]);
                this.IscreateProject(templateRef);
                //this.dialog.open(templateRefAccept);
                // window.open(task.formLink, '_blank');

              } else {
                let splitURl = task.formLink.split('token=');
                this.getQueryParameterFromLink(splitURl[1]);
                this.IscreateProject(templateRef);
                //this.dialog.open(templateRefAccept);
                // window.open('https://' + task.formLink, '_blank');
              }
            } else {
              this.toastr.warning('No URL or link is provided to open.', '', {
                timeOut: 3000,
              });
              this.loaderService.hide();
            }
            //this.loaderService.hide();
          }
        }
      }
    });
  }

  getShortName(fullName, type) {
    return fullName.split(' ').map(n => n[0]).join('');
  }

  // Remove Relation 
  RemoveRelation(group) {
    const message = `Are you sure you want to delete this participant?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          //this.loaderService.show();
          if (group !== undefined) {
            this.projectGroups.forEach(e => {
              if (e.projGrpRelationParticipantList.length > 0) {
                e.projGrpRelationParticipantList.forEach(ee => {
                  if (ee.groupRelationParticipantMappingID == group.groupRelationParticipantMappingID) {
                    ee.contactEmail = "";
                    ee.participantName = "";
                  }
                });
              }
            });
          }

          

          if (group !== undefined) {
            this.loaderService.show();
            var relationListModels = [];
            var req = {
              groupRelationParticipantMappingID: group.groupRelationParticipantMappingID,
              groupID: group.groupID,
              relationColour: group.relationColour,
              contactID: null,
              relationID: group.relationID,
              projectID: this.projectId, //sessionStorage.getItem('projectID'),
              roleID: null,
            }
            relationListModels.push(req)

            var ReqModel = {
              relationListModels: relationListModels,
              userID: this.userIDURL,
              organizationID: Number(this.organizationIdURL),
              databaseID: Number(this.databaseIdURL),
              type:1,// 1 for Project and 2 for Template
              OfficeID:this.myOfficeID
            }
            this.formsService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe((response) => {
              if (response != undefined) {
                this.responseHolder = response;
                if (this.responseHolder.status == this.statusConstant.statusSuccess) {
                  this.loaderService.hide();
                 // this.GetGroupList(sessionStorage.getItem('projectID'));
                  this.toastr.success('Participant removed successfully', '', {
                    timeOut: 3000,
                  });
                }
              } else {
                this.loaderService.hide();
              }
            });
          }

          if (this.projectGroups.length > 0) {
            var check = []
            check = this.projectGroups.filter(x => x.groupType === 1);
            if (check.length > 0) {
              for (var i = 0, len = check.length; i < len; ++i) {
                var projGrpRelationParticipantList = [];
                projGrpRelationParticipantList = check[i].projGrpRelationParticipantList;
                if (projGrpRelationParticipantList.length > 0) {
                  for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                    if (projGrpRelationParticipantList[i1].contactEmail != "" || projGrpRelationParticipantList[i1].participantEmail != "" || projGrpRelationParticipantList[i1].roleID != "0") {
                      this.SendButtonDisabled = true;
                      return;
                    } else {
                      this.SendButtonDisabled = false;
                      // return;
                    }
                  }
                }
                else {
                }
              }
            }
          }
          
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  IscreateProject(templateRef: TemplateRef<any>) {
    this.CreateProjectFromFormLink(templateRef);
  }

  CreateProjectFromFormLink(templateRef: TemplateRef<any>) {
    this.loaderService.show();
    this.projectGroups = [];
    var ReqModel = {
      formID: this.formID,
      userID: this.userIDURL,
      organizationID: Number(this.organizationIdURL),
      databaseID: Number(this.databaseIdURL),
      officeID: this.myOfficeIDURL,
      TaskID: this.TaskIDURL,
      UserEmailForCode: sessionStorage.getItem('userEmailForCode')
    }
    this.formsService.CreateProjectFromFormLink(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.dialog.open(templateRef, {
          panelClass: 'signatureModal',
        });
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.projectGroups = this.responseHolder.data;
          if (this.projectGroups.length > 0) {
            for (var i = 0, lennew = this.projectGroups.length; i < lennew; ++i) {
              var projGrpRelationParticipantList = [];
             // this.projectGroups[i].projGrpRelationParticipantList = this.projectGroups[i].projGrpRelationParticipantList.filter(m => m.isApprover != true);
              projGrpRelationParticipantList = this.projectGroups[i].projGrpRelationParticipantList;
              if (projGrpRelationParticipantList.length > 0) {
                this.participantMessageInfo = this.projectGroups[0].participantMessageInfo;
                for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                  // var matchRole=[];
                  // matchRole= this.MatchingRole.filter(m=>m.roleName==projGrpRelationParticipantList[i1].relationName);  
                  // if(matchRole.length > 0){
                  //   this.projectGroups[i].projGrpRelationParticipantList[i1].selectedContactFieldEmailID=matchRole;
                  // }else{
                  //   this.projectGroups[i].projGrpRelationParticipantList[i1].selectedContactFieldEmailID=null;
                  // }              
                }
              }
              else {
              }
            }
          }


          if (this.projectGroups.length > 0) {
            this.projectId = this.projectGroups[0].projectID;
          }

          var data = [];
          data = this.projectGroups

          if (data.length > 0) {
            this.eventLogMessage = "Sent for signature to ";
            var checkGroup = this.projectGroups.filter(m => m.groupType == 1);
            if (checkGroup.length > 0) {
              var projGrpRelationParticipantList = [];
              projGrpRelationParticipantList = checkGroup[0].projGrpRelationParticipantList;
              for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                var checkEmailAnonmous = projGrpRelationParticipantList[i1].contactEmail;
                var checkEmail = projGrpRelationParticipantList[i1].participantEmail;
                var email = "";
                if (checkEmailAnonmous != "") {
                  email = checkEmailAnonmous;
                  this.eventLogMessage += '(' + email + '), ';
                }
                if (checkEmail != "") {
                  email = checkEmail;
                  this.eventLogMessage += '(' + email + '), ';
                }
              }
            }

            var checkViewOnly = this.projectGroups.filter(m => m.groupType == 3);
            if (checkViewOnly.length > 0) {
              for (var i = 0, len4 = checkViewOnly.length; i < len4; ++i) {
                var projGrpRelationParticipantList = [];
                projGrpRelationParticipantList = checkViewOnly[i].projGrpRelationParticipantList;
                for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                  var checkEmailAnonmous = projGrpRelationParticipantList[i1].contactEmail;
                  var checkEmail = projGrpRelationParticipantList[i1].participantEmail;
                  var email = "";
                  if (checkEmailAnonmous != "") {
                    email = checkEmailAnonmous;
                    this.eventLogMessage += '(' + email + '), ';
                  }
                  if (checkEmail != "") {
                    email = checkEmail;
                    this.eventLogMessage += '(' + email + '), ';
                  }
                }
              }
            }
          }

          this.eventLogMessage = this.eventLogMessage.replace(/,\s*$/, "");


          this.loaderService.hide();
          this.spinner = false;
          var check = []
          check = this.responseHolder.data.filter(x => x.groupType === 1);
          if (check.length > 0) {
            for (var i = 0, len = check.length; i < len; ++i) {
              var projGrpRelationParticipantList = [];
              projGrpRelationParticipantList = check[i].projGrpRelationParticipantList;
              if (projGrpRelationParticipantList.length > 0) {
                for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                  if (projGrpRelationParticipantList[i1].contactEmail != "" || projGrpRelationParticipantList[i1].participantEmail != "" || projGrpRelationParticipantList[i1].roleID != "0") {
                    this.SendButtonDisabled = true;
                    return;
                  } else {
                    this.SendButtonDisabled = false;
                    // return;
                  }
                }
              }
              else {
              }
            }
          }

        } else {
          this.loaderService.hide();
          this.projectGroups = [];
          this.dialog.closeAll();
        }
      } else {
        this.loaderService.hide();
        this.projectGroups = [];
        this.dialog.closeAll();
      }
    });

  }

  GetparticipantIfprojectExists(templateRef: TemplateRef<any>, projectID: any) {
    this.loaderService.show();
    this.projectGroups = [];
    var ReqModel = {
      formID: this.formID,
      userID: this.userIDURL,
      organizationID: Number(this.organizationIdURL),
      databaseID: Number(this.databaseIdURL),
      officeID: this.myOfficeID,
      TaskID: this.TaskIDURL,
      projectID: projectID,
      UserEmailForCode: sessionStorage.getItem('userEmailForCode')
    }   
    this.formsService.CreateProjectFromFormLink(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.dialog.open(templateRef, {
          panelClass: 'signatureModal',
        });

        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.projectGroups = this.responseHolder.data;
          if (this.projectGroups.length > 0) {
            this.participantMessageInfo = this.projectGroups[0].participantMessageInfo;
            for (var i = 0, lennew = this.projectGroups.length; i < lennew; ++i) {
              var projGrpRelationParticipantList = [];
              this.projectGroups[i].projGrpRelationParticipantList = this.projectGroups[i].projGrpRelationParticipantList.filter(m => m.isApprover != true)
              projGrpRelationParticipantList = this.projectGroups[i].projGrpRelationParticipantList;
              if (projGrpRelationParticipantList.length > 0) {
                for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                  // var matchRole=[];
                  // matchRole= this.MatchingRole.filter(m=>m.roleName==projGrpRelationParticipantList[i1].relationName);  
                  // if(matchRole.length > 0){
                  //   this.projectGroups[i].projGrpRelationParticipantList[i1].selectedContactFieldEmailID=matchRole;
                  // }else{
                  //   this.projectGroups[i].projGrpRelationParticipantList[i1].selectedContactFieldEmailID=null;
                  // }              
                }
              }
              else {
              }
            }
          }


          if (this.projectGroups.length > 0) {
            this.projectId = this.projectGroups[0].projectID;
          }

          var data = [];
          data = this.projectGroups
          if (data.length > 0) {
            this.eventLogMessage = "Sent for signature to ";
            var checkGroup = this.projectGroups.filter(m => m.groupType == 1);
            if (checkGroup.length > 0) {
              var projGrpRelationParticipantList = [];
              projGrpRelationParticipantList = checkGroup[0].projGrpRelationParticipantList;
              for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                var checkEmailAnonmous = projGrpRelationParticipantList[i1].contactEmail;
                var checkEmail = projGrpRelationParticipantList[i1].participantEmail;
                var email = "";
                if (checkEmailAnonmous != "") {
                  email = checkEmailAnonmous;
                  this.eventLogMessage += '(' + email + '), ';
                }
                if (checkEmail != "") {
                  email = checkEmail;
                  this.eventLogMessage += '(' + email + '), ';
                }
              }
            }

            var checkViewOnly = this.projectGroups.filter(m => m.groupType == 3);
            if (checkViewOnly.length > 0) {
              for (var i = 0, len4 = checkViewOnly.length; i < len4; ++i) {
                var projGrpRelationParticipantList = [];
                projGrpRelationParticipantList = checkViewOnly[i].projGrpRelationParticipantList;
                for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                  var checkEmailAnonmous = projGrpRelationParticipantList[i1].contactEmail;
                  var checkEmail = projGrpRelationParticipantList[i1].participantEmail;
                  var email = "";
                  if (checkEmailAnonmous != "") {
                    email = checkEmailAnonmous;
                    this.eventLogMessage += '(' + email + '), ';
                  }
                  if (checkEmail != "") {
                    email = checkEmail;
                    this.eventLogMessage += '(' + email + '), ';
                  }
                }
              }
            }
          }

          this.eventLogMessage = this.eventLogMessage.replace(/,\s*$/, "");


          var check = []
          check = this.responseHolder.data.filter(x => x.groupType === 1);
          if (check.length > 0) {
            for (var i = 0, len = check.length; i < len; ++i) {
              var projGrpRelationParticipantList = [];
              projGrpRelationParticipantList = check[i].projGrpRelationParticipantList;
              if (projGrpRelationParticipantList.length > 0) {
                for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                  if (projGrpRelationParticipantList[i1].contactEmail != "" || projGrpRelationParticipantList[i1].participantEmail != "" || projGrpRelationParticipantList[i1].roleID != "0") {
                    this.SendButtonDisabled = true;
                    this.loaderService.hide();
                    return;
                  } else {
                    this.SendButtonDisabled = false;
                    // return;
                  }
                }
              }
              else {
              }
            }
          }
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
          this.projectGroups = [];
          this.dialog.closeAll();
        }
      } else {
        this.loaderService.hide();
        this.projectGroups = [];
        this.dialog.closeAll();
      }
    });

  }

  close() {
    this.dialog.closeAll();
  }

  closeAssignParticipant() {
    if (this.dialogRef != undefined) {
      this.dialogRef.close();
      this.peoples = [];
      this.SendButtonDisabled = false;
      this.showAddButton = false;
    }
  }

  closeAssign() {
    if (this.dialog != undefined) {
      this.dialog.closeAll();
      this.peoples = [];
      this.SendButtonDisabled = false;
      this.showAddButton = false;
    }
  }

  assignUser(templateRef: TemplateRef<any>, isShare: boolean, isRole: boolean, contact: any, p, p1) {
    this.type = p1.type;
    this.projectId = p1.projectID;
    this.groupRelationParticipantMappingID = p.groupRelationParticipantMappingID;
    this.groupID = p.groupID;
    this.relationColour = p.relationColour;
    this.relationID = p.relationID;
    this.showAddButton = false;
    this.contactemail = p.contactEmail;
    this.transRoleList = [];
    this.contactsList = [];
    this.Roles = [];
    this.peoples = [];
    this.selectedsharedAccessRole = [];
    this.participantEmail = "";
    this.showContactRoleAddButton = false;
    this.dialogRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox'
    });
  }

  ProjectSend(templateRefAccept: TemplateRef<any>, templateRef: TemplateRef<any>) {
    this.dialog.closeAll();
    var ReqModel = {
      folderId: 1,
      projectId: this.projectId,
      projectName: "",
      userID: this.userIDURL,
      organizationID: Number(this.organizationIdURL),
      databaseID: Number(this.databaseIdURL),
      type: 1,  // 1 Form Send , 2 Sand an Save , 3 Save Template Only 
      fileManagerFolderId: 0
    }
    this.loaderService.show()
    this.formsService.AddProjectInfoAsTemplete(ReqModel).subscribe((response) => {
      if (response != undefined) {
        if (response.status == this.statusConstant.statusSuccess && response.data != null) {
          this.loaderService.hide();
          this.AddProjectEventLog();
          //this.TaskList.getTaskDetailResponseDTOs.find(m=> m.taskId==this.selectedTask.taskId).projectID=this.projectId;

          this.showExternalTaskList.forEach(tg => {
            if (tg.tasks !== undefined && tg.tasks !== null) {
              tg.tasks.forEach(ts => {
                if (ts.taskId == this.selectedTask.taskId) {
                  ts.projectID = this.projectId;
                }
              });
            }
          });
          this.toastr.success('Form has sent successfully to participants.', '', {
            timeOut: 3000,
          });
          this.specialUpdate(this.selectedTask);
          this.GetSigningLinkForParticipantIfExists(this.selectedTask, templateRefAccept, templateRef);
          //this.router.navigate(['/request/thanks'], { state:{isSent: true }});
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }
  databaseId(databaseId: any) {
    throw new Error('Method not implemented.');
  }

  // To Add Project EventLog //
  async AddProjectEventLog() {
    try {
      var ReqModel = {
        projectID: this.projectId,
        ipAddress: this.ipAddress,
        message: this.eventLogMessage,
        eventType: 1, //Sent=1, View=2, Sign=3, Complete=4, Decline=5, Assign=6
        device: this.device,
        browser: this.browsername,
        userID: this.userIDURL,
        organizationID: Number(this.organizationIdURL),
        databaseID: Number(this.databaseIdURL),
      }
      const result = await this.formsService.AddProjectEventLog(ReqModel).toPromise();
      this.responseHolder = result;
      if (this.responseHolder.status === this.statusConstant.statusSuccess) {
      } else {
        this.loaderService.hide();
      }
    } catch (e) {
      Observable.throw(e);
    }
  }
  contactSelected(contactSelected: any) {
    this.peoples = [];
    let user = this.peoples.find(m => m.contactID == contactSelected.contactID);
    if (user == undefined || user == '' || user == null) {
      if (contactSelected.contactID == 0) {
        return;
      }
      if (contactSelected.email == "" || contactSelected.email == null || contactSelected.email == undefined) {
        this.toastr.warning('Selected contact is not associated with email.', '', {
          timeOut: 3000,
        });
        return;
      }
      var ReqModel = {
        contactID: contactSelected.contactID,
        email: contactSelected.email,
        name: contactSelected.name,
        img: contactSelected.imageUrl,
        shortName: contactSelected.shortName,
      }
      this.peoples.unshift(ReqModel);
      this.stateCtrl.reset();
      if (this.peoples.length > 0) {
        this.showAddButton = true;
      } else {
        this.showAddButton = false;
      }
    }
  }

  getUpdatedDate(dueDate) {
    if (dueDate != null) {
      const d = new Date(dueDate);
      // d.setDate(d.getDate() + 1);
      // This will return an ISO string matching your local time.
      var date = new Date(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes() - d.getTimezoneOffset()).toISOString();
      return this.datePipe.transform(date, "MM/dd/yyyy");
    }
  }


  authenticationMobile: string = "";
  showEmail: boolean = false;
  showMobile: boolean = false;
  sendTokenButton: boolean = true;
  sendSubmitButton: boolean = false;
  tokenotpCode: boolean = false;
  showAuthenticationType = true;

  getTokenEmail(value: MatRadioChange) {
    this.showEmail = true;
    this.showMobile = false;

    this.sendTokenButton = false;
  }

  getTokenMobile(value: MatRadioChange) {
    this.showEmail = false;
    this.showMobile = true;

    this.sendTokenButton = false;
  }

  getToogleInformation() {
    this.toogleInformation = !this.toogleInformation;
  }

  //@ViewChild('singleTaskTemp') content: TemplateRef<any>;
  @ViewChild('singleTaskTemp', { static: true }) content: TemplateRef<any>;
 openSingleTask(){
  this.dialogRef = this.dialog.open(this.content);
  // this.dialogRef = this.dialog.open(this.content, {
  //   panelClass: 'custom-modalbox'
  // });
 }
}

